import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
interface PlanoCurricular {
  id: string;
  nome: string;
}
@Injectable({
  providedIn: 'root'
})
export class PlanoCurricularService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all Plano Curricular
  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: PlanoCurricular[] }>(`${this.path}/getAllPlanoCurricular`, params ? new HttpParams({
      fromObject: params
    }) : this.params).pipe(
      map(response => response)
    );
  }

  // Get Plano Curricular by ID
  public show(id: string): Observable<PlanoCurricular> {
    return this.apiService.get<{ object: PlanoCurricular }>(`${this.path}/getPlanoCurricularById/${id}`).pipe(
      map(response => response.object as PlanoCurricular)
    );
  }

  // Create new Plano Curricular
  public store(planoCurricular: PlanoCurricular): Observable<PlanoCurricular> {
    return this.apiService
      .post<{ object: PlanoCurricular }>(`${this.path}/AddPlanoCurricular`, planoCurricular)
      .pipe(
        map((response) => response.object as PlanoCurricular)
      );
  }

  // Update existing Plano Curricular
  public update(planoCurricular: PlanoCurricular): Observable<PlanoCurricular> {
    return this.apiService
      .put<{ object: PlanoCurricular }>(`${this.path}/UpdatePlanoCurricular`, planoCurricular)
      .pipe(
        map((response) => response.object as PlanoCurricular)
      );
  }

  // Delete existing Plano Curricular
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeletePlanoCurricularById/${id}`);
  }
}
